/**Модель создания папки файлов для комментария */
export class CreateCommentFileFolderModel {
  /**ID проекта */
  ProjectId!: number;
  /**ID задачи */
  TaskId!: number;

  constructor(obj?: Partial<CreateCommentFileFolderModel>) {
    Object.assign(this, obj);
  }
}
